import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { AuthorizationRules } from 'common/constants';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import ExpenseList from 'legacy-modules/other-expense/list';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useTourExpenseAction(tour: TourModel) {
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const id = tour.id;

  const tourExpensePermission = can(AuthorizationRules.ToursGetOtherExpenses);

  const onGetTourExpense = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <ExpenseList type="Tour" data={tour} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, tour]);

  const tourExpenseAction: PopoverMenuType = {
    key: `tour-expense-${id}`,
    label: t('common:other_expenses'),
    onClick: onGetTourExpense,
    isAllowed: tourExpensePermission,
  };

  return {
    tourExpensePermission,
    tourExpenseAction,
  };
}
